import { render, staticRenderFns } from "./Masturbator.vue?vue&type=template&id=072507a7&scoped=true&"
import script from "./Masturbator.vue?vue&type=script&lang=js&"
export * from "./Masturbator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072507a7",
  null
  
)

export default component.exports